import { createElementBlock as t, openBlock as C, createElementVNode as n } from "vue";
const o = {
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-location-outline"
};
function l(i, e) {
  return C(), t("svg", o, e[0] || (e[0] = [
    n("path", {
      d: "M17 10.95C17.7578 10.95 18.4845 11.2397 19.0203 11.7555C19.5561 12.2712 19.8571 12.9707 19.8571 13.7C19.8571 14.0611 19.7832 14.4187 19.6397 14.7524C19.4961 15.086 19.2856 15.3892 19.0203 15.6445C18.755 15.8999 18.44 16.1025 18.0934 16.2407C17.7467 16.3789 17.3752 16.45 17 16.45C16.2422 16.45 15.5155 16.1603 14.9797 15.6445C14.4439 15.1288 14.1429 14.4293 14.1429 13.7C14.1429 12.9707 14.4439 12.2712 14.9797 11.7555C15.5155 11.2397 16.2422 10.95 17 10.95ZM17 6C19.1217 6 21.1566 6.81125 22.6569 8.25528C24.1571 9.69931 25 11.6578 25 13.7C25 19.475 17 28 17 28C17 28 9 19.475 9 13.7C9 11.6578 9.84285 9.69931 11.3431 8.25528C12.8434 6.81125 14.8783 6 17 6ZM17 8.2C15.4845 8.2 14.031 8.77946 12.9594 9.81091C11.8878 10.8424 11.2857 12.2413 11.2857 13.7C11.2857 14.8 11.2857 17 17 24.381C22.7143 17 22.7143 14.8 22.7143 13.7C22.7143 12.2413 22.1122 10.8424 21.0406 9.81091C19.969 8.77946 18.5155 8.2 17 8.2Z",
      fill: "#2F2F2F",
      class: "svg__fill--heading-grey"
    }, null, -1)
  ]));
}
const s = { render: l };
export {
  s as default,
  l as render
};
